import React from 'react';
import { Platform, Text, TextInput, Image } from 'react-native';
import Utils from 'utils/utils';
import CommonBridge from './CommonBridge';
import CommonStyles from './CommonStyles';

/**
 * 安卓Mitype加粗不生效，这里设置为加粗字体
 */
function setMitypeBoldFont(styles) {
  if (Platform.OS !== 'android' || CommonStyles.isInSpecialDevice) {
    return null;
  }
  if (
    (Array.isArray(styles) && styles.some((item) => item?.fontFamily && item?.fontWeight)) ||
    (!Array.isArray(styles) && styles && styles?.fontFamily && styles?.fontWeight)
  ) {
    return null;
  }

  const boldMitypeStyle = {
    fontFamily: 'Mitype-Bold',
    fontWeight: 'normal',
  };

  const checkValue = (value) => {
    if (value === 'bold') {
      return true;
    }
    const number = Number(value);
    if (!isNaN(number)) {
      return number >= 600;
    }
  };

  let fontStyle = {
    fontWeight: 'normal',
  };

  let fontWeightValue = null;
  let fontFamilyValue = null;
  let fontSizeValue = null;

  if (Array.isArray(styles) && styles.length) {
    styles.forEach((item) => {
      if (item && item.fontWeight) {
        fontWeightValue = item.fontWeight;
      }
      if (item && item.fontFamily) {
        fontFamilyValue = item.fontFamily;
      }
      if (item && item.fontSize) {
        fontSizeValue = item.fontSize;
      }
    });
  } else {
    if (styles && styles.fontWeight) {
      fontWeightValue = styles.fontWeight;
    }
    if (styles && styles.fontFamily) {
      fontFamilyValue = styles.fontFamily;
    }
    if (styles && styles.fontSize) {
      fontSizeValue = styles.fontSize;
    }
  }

  if (styles && !fontFamilyValue && checkValue(fontWeightValue)) {
    fontStyle = boldMitypeStyle;
  }

  if (fontSizeValue) {
    return fontStyle;
  } else {
    return {
      ...fontStyle,
      // fontSize: CommonStyles.ScaleFontSize(14),
    };
  }
}
/**
 * 设置Android上的默认字体
 */
function ResettingDefaultSetting() {
  if (!CommonBridge.isWeb()) {
    // TextInput - 禁止缩放
    if (TextInput.defaultProps) {
      TextInput.defaultProps.allowFontScaling = false;
    }

    if (Platform.OS === 'android') {
      const oldTextInput = TextInput;
      TextInput.defaultProps = {
        ...oldTextInput.defaultProps,
        fontFamily: 'Mitype-DemiBold',
      };
    }

    // Text - 设置字体，禁止缩放
    const defaultFontFamily = {
      ...Platform.select({
        android: CommonStyles.androidFontStyle,
        ios: CommonStyles.iosFontStyle,
      }),
    };

    const textDefaultPaddingStyle = {
      includeFontPadding: false,
      textAlignVertical: 'center',
    };

    const oldTextRender = Text.render;
    Text.render = function (...args) {
      const origin = oldTextRender.call(this, ...args);
      const style = origin.props.style;
      const defaultStyle = CommonBridge.isAndroid() ? textDefaultPaddingStyle : null;
      const fontStyle = setMitypeBoldFont(style);
      const originStyle = Array.isArray(style)
        ? [defaultFontFamily, defaultStyle, ...style, fontStyle]
        : [defaultFontFamily, defaultStyle, style, fontStyle];

      return React.cloneElement(origin, {
        allowFontScaling: false,
        style: originStyle,
      });
    };
  }

  Image.defaultProps = {
    // enum('cover', 'contain', 'stretch', 'repeat', 'center')
    ...Image.defaultProps,
    resizeMode: CommonBridge.isWeb() ? 'cover' : 'contain',
  };

  const oldImageDerivedStateFromPorops = Image.getDerivedStateFromProps;
  Image.getDerivedStateFromProps = function (props, state) {
    console.log('image: getDerivedStateFromProps:', props);
    const oldSource = props.source;
    if (typeof oldSource === 'function') {
      props.source = oldSource();
    }
    return oldImageDerivedStateFromPorops(props, state);
  };

  const oldResolveAssetSource = Image.resolveAssetSource;
  Image.resolveAssetSource = function (source) {
    const oldSource = source;
    if (typeof oldSource === 'function') {
      props.source = oldSource();
    }
    return oldResolveAssetSource(oldSource);
  };

  const oldImageRender = Image.render;
  Image.render = function (...args) {
    const props = args[0];
    const newProps = {};
    if (typeof props.source === 'function') {
      newProps.source = props.source();
    } else {
      newProps.source = props.source;
    }
    for (const key of Object.keys(props)) {
      if (key !== 'source') {
        newProps[key] = props[key];
      }
    }
    args[0] = newProps;
    const origin = oldImageRender.call(this, ...args);
    return origin;
  };
  // 生产模式禁掉console输出 https://www.tapd.cn/53785107/bugtrace/bugs/view/1153785107001049507
  if (!__DEV__) {
    console.log = () => {};
  }

  // 生产模式禁掉console输出 https://www.tapd.cn/53785107/bugtrace/bugs/view/1153785107001049507
  if (!__DEV__) {
    console.log = () => {};
  }
}

export { ResettingDefaultSetting };
